import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <section id="contact" className="spine-layout contact-section">
      <div className="spine-col">
        <span>Contact</span>
      </div>
      <div className="contact-inner">
        <div className="contact-heading">
          Got a project in mind?<br />
          <span className="contact-dim">Let's talk about it.</span>
        </div>
        <div className="contact-links">
          <a href="mailto:me@shahd.me" className="contact-link main">
            me@shahd.me
            <span className="link-arrow">↗</span>
          </a>
          <a
            href="https://linkedin.com/in/shahdabubaker"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
          >
            LinkedIn
            <span className="link-arrow">↗</span>
          </a>
          <a
            href="https://wa.me/962780000270?text=Hi%20Shahd%2C%20I%27d%20like%20to%20discuss%20a%20project"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
          >
            WhatsApp
            <span className="link-arrow">↗</span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Contact;
